// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eBii1","col":"styles_col__38D1_","actions":"styles_actions__288ci","conflict":"styles_conflict__1IHjK"};